// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__3IG6m","inverse":"Logo_inverse__1Nw59","stories":"Logo_stories__ZKxxB"};